import * as React from 'react';

import { LinksList } from './LinksList';
import * as style from './style.css';
import { Tabs } from './Tabs';
import { getDefaultTab } from './utils/getDefaultTab';
import { trackQuickLinksView } from '../../utils/tracking';
import { IQuickLinksTab } from '../../../../../types/quickLinks';

interface IQuickLinksTabsComponentProps {
  tabs: IQuickLinksTab[];
}

export const QuickLinksTabsComponent = ({ tabs }: IQuickLinksTabsComponentProps) => {
  const [selectedTab, setSelectedTab] = React.useState(getDefaultTab(tabs));
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    trackQuickLinksView();
  }, []);

  const onTabChange = React.useCallback((_: React.ChangeEvent<HTMLInputElement>, value: number) => {
    setSelectedTab(value);
  }, []);

  const onMoreButtonClick = React.useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  const links = React.useMemo(() => tabs[selectedTab].links, [tabs, selectedTab]);

  return (
    <div className={style['container']}>
      {isExpanded && <Tabs tabs={tabs} value={selectedTab} onChange={onTabChange} />}
      <LinksList links={links} isExpanded={isExpanded} onMoreButtonClick={onMoreButtonClick} />
    </div>
  );
};
